import {
  NativeStackHeaderProps,
  Stack,
  useLocalSearchParams,
} from 'expo-router';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { StyleSheet, View } from 'react-native';
import { useSafeAreaInsets } from 'react-native-safe-area-context';
import PdfViewer from 'shared/components/PdfRenderer/PdfViewer';
import LoadingSpinner from 'shared/components/vxl/loading/LoadingSpinner/LoadingSpinner';
import ExpoNavigationBar from 'shared/components/vxl/navigation/ExpoNavigationBar/ExpoNavigationBar';
import ScreenTransitionOverlay from 'shared/patterns/vxl/ScreenTransitionOverlay/ScreenTransitionOverlay';
import theme from 'shared/styles/theme';

const BelieveAgreementScreen = () => {
  const { bottom } = useSafeAreaInsets();
  const { agreementLink } = useLocalSearchParams<{ agreementLink?: string }>();
  const { t: translatedText } = useTranslation('believe');

  return (
    <View style={[styles.container, { paddingBottom: bottom }]}>
      {agreementLink ? (
        <>
          <Stack.Screen
            options={{
              title: translatedText(
                'application.agreements.believeProgramAgreementsTitle',
              ),
              headerBackVisible: true,
              headerShown: true,
              header: (props: NativeStackHeaderProps) => (
                <ExpoNavigationBar {...props} />
              ),
            }}
          />
          <PdfViewer url={agreementLink} />
        </>
      ) : (
        <View style={styles.loaderContainer}>
          <ScreenTransitionOverlay
            isLoading={agreementLink === undefined}
            LoadingComponent={<LoadingSpinner />}
            ErrorComponent={null}
          />
        </View>
      )}
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    backgroundColor: theme.color.background.primary,
    flex: 1,
    height: '100%',
  },
  loaderContainer: {
    alignItems: 'center',
    flex: 1,
    justifyContent: 'center',
  },
});

export default BelieveAgreementScreen;
